import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { studentview, teacherview } from "../service/dashboard";
import moment from "moment";

const MyCertificate = () => {
    const [certList, setCertList] = useState([]);
    const [loading, setLoading] = useState(true);
    const reportUrl = localStorage.getItem("reportUrl") || "";

    useEffect(() => {
        const role = localStorage.getItem("Role");
        const uid = localStorage.getItem("UID");

        const handleCerts = (res) => {
            setLoading(false);
            if (res.status === true && res.data.certificates && res.data.certificates.length > 0) {
                setCertList(res.data.certificates);
            }
        };

        if (role === "4") {
            studentview(uid).then(handleCerts).catch(() => setLoading(false));
        } else if (role === "5") {
            teacherview(uid).then(handleCerts).catch(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    function certPdfUrl(pdfPath) {
        if (!pdfPath) return "";
        if (pdfPath.startsWith("http")) return pdfPath;
        return reportUrl + pdfPath;
    }

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={8} className="text-left align-self-end">
                            <h4 className="morehead-text">My Certificates</h4>
                        </Col>
                        <Col xs={4} className="text-right align-self-end">
                            <Link to="/dashboard" className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>

                <div className="p-3">
                    {loading && (
                        <div className="text-center py-5">
                            <div className="spinner-border text-success" role="status"></div>
                        </div>
                    )}

                    {!loading && certList.length === 0 && (
                        <p className="text-center text-danger fw-bold mt-4">
                            No Certificates Generated Yet.
                        </p>
                    )}

                    {!loading && certList.length > 0 && (
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle text-center">
                                <thead className="table-light table-head-color">
                                    <tr>
                                        <th>#</th>
                                        <th>Certificate Type</th>
                                        <th>Generated Date</th>
                                        <th>Total Generated</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {certList.map((cert, idx) => {
                                        const count = certList.filter(c => c.cert_type === cert.cert_type).length;
                                        return (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>
                                                    <i className="fa fa-certificate me-2" style={{ color: "#6259ca" }}></i>
                                                    {cert.cert_label}
                                                </td>
                                                <td>{moment(cert.generated_date).format("DD-MM-YYYY")}</td>
                                                <td>
                                                    <span className="badge bg-primary">
                                                        {count} time{count !== 1 ? "s" : ""}
                                                    </span>
                                                </td>
                                                <td>
                                                    {cert.pdf_path ? (
                                                        <a
                                                            className="btn btn-success btn-sm"
                                                            href={certPdfUrl(cert.pdf_path)}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            download
                                                        >
                                                            <i className="fa fa-download me-1"></i> PDF
                                                        </a>
                                                    ) : (
                                                        <span className="text-muted">—</span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MyCertificate;
